/*global
    jQuery
*/
(function ($) {
    $(document).ready(function() {
      $.ajaxSetup({ cache: true });
      $.getScript('//connect.facebook.net/en_US/sdk.js', function(){
        FB.init({
          appId: '135014960599641',
          version: 'v2.11'
        });     
      });
    
      var shareToFacebook = function(e) {
          e.preventDefault();
          console.log('clicked!');
          var shareUrl = $(this).data('fbshare-url');
          var label = $(this).data('evtlabel');
          console.log(label);
          if (typeof shareUrl !== 'undefined' && shareUrl.length > 0) {
            FB.ui({
                method: 'share',
                href: shareUrl
            }, function(response) {
                if (typeof response === 'undefined') {
                    console.log('Cancelled share of PDP');
                    if (typeof ga !== 'undefined') {
                        console.log('ga is defined');
                        ga('send', 'event', 'Owner Dashboard', 'Cancelled Share of PDP on Facebook', label);
                    } else {
                        console.log('ga is not defined');
                    }
                } else {
                    console.log('User shared PDP');
                    if (typeof ga !== 'undefined') {
                        console.log('ga is defined');
                        ga('send', 'event', 'Owner Dashboard', 'Share PDP on Facebook', label);
                    } else {
                        console.log('ga is not defined');
                    }
                }
            });
          }
      }

      var facebookElementLoadEvent = function(element) {
          var $element = $(element);
          var label = $element.data('loadedevent');
          if ($element.is(':visible')) {
              console.log('Element is visible');
              console.log(label);
              if (typeof ga !== 'undefined' && typeof label !== 'undefined' && label != '') {
                  console.log('ga is defined');
                  ga('send', 'event', 'Owner Dashboard', 'Share PDP on Facebook', label);
              }
          }
      }
 
      $('a.facebook-share-link').on('click', shareToFacebook);

      $(document).ready(function() {
          var $elements = $('div.facebook-share-banner, div.facebook-share-button');
          $.each($elements, function(key, value) {
              facebookElementLoadEvent(value);
          });
      });
    });
}(jQuery));
